import { useMachine } from '@xstate/react';
import { createContext, ReactNode } from 'react';
import { Interpreter, State } from 'xstate';

import { machine } from './machine';

/**
 * @todo type the events properly. Wasn't having any luck there, but
 * at least have context typed.
 */
export type ProspectorMachine = [
  State<typeof machine.context, any, any, any>,
  Interpreter<typeof machine.context, any, any, any>['send'],
];
/**
 * @todo type this properly. I couldn't even get GPT-4 to do it, so
 * not going to fight it while we try to get the basic glue in place.
 *
 * Most importantly, in `useProspector` we cast context back to
 * ProspectoMachine so all the TS/DX goodness remains.
 */
export const ProspectorContext = createContext<any>([]);

type ProspectorProviderProps = {
  children: ReactNode;
};
export function ProspectorProvider({ children }: ProspectorProviderProps) {
  const [state, send] = useMachine(machine);

  return (
    <ProspectorContext.Provider value={[state, send]}>
      {children}
    </ProspectorContext.Provider>
  );
}
